import { Component, EventEmitter, Output } from '@angular/core';
import { ReplySortingService } from 'src/app/core/services/ticket/reply-sorting.service';
import { MessagesOrder } from 'src/sb-tools/typescript/enums/messages-order.enum';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-thread-sort-control',
    templateUrl: './thread-sort-control.component.html',
    styleUrls: ['./thread-sort-control.component.scss'],
    imports: [TranslateModule],
})
export class ThreadSortControlComponent {
    @Output() changeMessageOrder: EventEmitter<any> = new EventEmitter();

    public messagesOrderEnum = MessagesOrder;

    constructor(public replySortingService: ReplySortingService) {}

    emitChangeMessageOrder() {
        this.changeMessageOrder.emit();
    }
}
